import React, { useState } from 'react';
import HelpCenter from './HelpCenter';
import ContactUs from './ContactUs';
import PrivacyPolicy from './PrivacyPolicy';
import TermsAndConditions from './TermsAndConditions';
import About from './About';
import '../styles/Help.css';

function Help({ onBack, user }) {
  const [activeSection, setActiveSection] = useState(null);

  const helpOptions = [
    {
      id: 'help-center',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
          <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
      ),
      title: 'Help Center',
      description: 'Get answers to common questions'
    },
    {
      id: 'contact-us',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
        </svg>
      ),
      title: 'Feedback',
      description: 'Reach out to our support team'
    },
    {
      id: 'privacy-policy',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
        </svg>
      ),
      title: 'Privacy Policy',
      description: 'Learn how we protect your data'
    },
    {
      id: 'terms-conditions',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
          <path d="M14 2v6h6"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <line x1="10" y1="9" x2="8" y2="9"/>
        </svg>
      ),
      title: 'Terms and Conditions',
      description: 'View our terms of service'
    },
    {
      id: 'about',
      icon: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <line x1="12" y1="16" x2="12" y2="12"/>
          <line x1="12" y1="8" x2="12.01" y2="8"/>
        </svg>
      ),
      title: 'About',
      description: 'Learn more about UcmaApp'
    }
  ];

  const handleOptionClick = (optionId) => {
    setActiveSection(optionId);
  };

  const handleBackToHelp = () => {
    setActiveSection(null);
  };

  // Render specific section if selected
  if (activeSection === 'help-center') {
    return (
      <HelpCenter
        onBack={handleBackToHelp}
        onContactSupport={() => setActiveSection('contact-us')}
      />
    );
  }

  if (activeSection === 'contact-us') {
    return <ContactUs onBack={handleBackToHelp} currentUser={user} />;
  }

  if (activeSection === 'privacy-policy') {
    return <PrivacyPolicy onBack={handleBackToHelp} />;
  }

  if (activeSection === 'terms-conditions') {
    return <TermsAndConditions onBack={handleBackToHelp} />;
  }

  if (activeSection === 'about') {
    return <About onBack={handleBackToHelp} />;
  }

  // Main help menu
  return (
    <div className="help-container">
      <div className="help-header">
        <button className="back-button" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5"/>
            <path d="M12 19l-7-7 7-7"/>
          </svg>
        </button>
        <h2>Help</h2>
      </div>

      <div className="help-content">
        <div className="help-options">
          {helpOptions.map((option) => (
            <div
              key={option.id}
              className="help-option-item"
              onClick={() => handleOptionClick(option.id)}
            >
              <div className="help-option-icon">
                {option.icon}
              </div>
              <div className="help-option-content">
                <div className="help-option-title">{option.title}</div>
                <div className="help-option-description">{option.description}</div>
              </div>
              <div className="help-option-arrow">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </div>
            </div>
          ))}
        </div>

        <div className="help-footer">
          <p className="help-footer-text">
            UcmaApp Version 1.0.0
          </p>
        </div>
      </div>
    </div>
  );
}

export default Help;

